import { FormikProps } from "formik/dist/types"
import clsx from "clsx"
import React, { ReactNode } from "react"
import { ObjectSchema } from "yup"
import useFormik from "./useFormik"
import InputMask from "react-input-mask"
import DatePicker, { registerLocale } from "react-datepicker"
import moment from "moment"
import fr from "date-fns/locale/fr"

registerLocale("fr", fr)

const MyDateMonthYearFormField = ({
     label,
     name,
     formikProps,
     placeholder,
     classNameLayout,
     classNameLabel,
     classNameField,
     autoFocus,
     validationSchema,
     minDate,
     maxDate,
     isClearable = true,
     isDisabled = false,
     onChange, // Destructured custom callback
}: IPropsModel) => {
     const { isFieldOnError, getFieldErrorMessage, isFieldRequired } = useFormik()

     return (
          <div className={clsx("row", classNameLayout)}>
               <div className={clsx("col-12 d-flex align-items-center", classNameLabel)}>
                    {label && (
                         <label
                              className={clsx("fs-6 fw-bolder text-gray-900", {
                                   required: validationSchema && isFieldRequired(validationSchema, name),
                              })}
                         >
                              {label}
                         </label>
                    )}
               </div>
               <div className={clsx("col-12", classNameField, { "mt-1": label })}>
                    <DatePicker
                         dateFormat="MM/yyyy"
                         showMonthYearPicker
                         locale="fr"
                         placeholderText={placeholder}
                         customInput={
                              <InputMask className={"form-control"} mask="99/9999">
                                   {() => (
                                        <input
                                             type="text"
                                             inputMode={"numeric"}
                                             placeholder={placeholder}
                                             className={clsx("form-control bg-transparent", {
                                                  "border-danger": formikProps && isFieldOnError(formikProps, name),
                                             })}
                                             autoFocus={autoFocus}
                                             onBlurCapture={() => formikProps?.setFieldTouched(name, true)}
                                        />
                                   )}
                              </InputMask>
                         }
                         name={name}
                         minDate={minDate ? moment(minDate).toDate() : null}
                         maxDate={maxDate ? moment(maxDate).toDate() : null}
                         isClearable={isClearable}
                         disabled={isDisabled}
                         selected={formikProps?.getFieldProps(name).value ? moment(formikProps.getFieldProps(name).value).toDate() : null}
                         onChange={(val: any) => {
                              formikProps?.setFieldTouched(name, true)
                              if (val) {
                                   // Formats the date as YYYY-MM
                                   const d = moment(val).format("YYYY-MM")
                                   formikProps?.setFieldValue(name, d)

                                   // Propagates the change to the parent if an onChange prop is provided
                                   if (onChange) {
                                        onChange(d)
                                   }
                              } else {
                                   formikProps?.setFieldValue(name, null)
                                   if (onChange) {
                                        onChange(null)
                                   }
                              }
                         }}
                    />
                    {formikProps && isFieldOnError(formikProps, name) && <div className="text-danger mt-1">{getFieldErrorMessage(formikProps, name)}</div>}
               </div>
          </div>
     )
}

interface IPropsModel {
     label?: ReactNode
     name: string
     formikProps: FormikProps<any> | null
     placeholder: string
     classNameLayout?: string
     classNameLabel?: string
     classNameField?: string
     autoFocus?: boolean
     validationSchema?: ObjectSchema<any>
     minDate?: string | null
     maxDate?: string | null
     isClearable?: boolean
     isDisabled?: boolean
     // Optional callback prop to handle logic outside Formik
     onChange?: (val: string | null) => void
}

export default MyDateMonthYearFormField
